module.exports = __webpack_public_path__ + "assets/img/pie-high.4cabd53d.svg";